import { doc, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { db } from "../network/firebaseConfig";
import CustomSelect from "./common/CustomSelect";

const roles = ["helpdesk", "technician", "supervisor", "admin"];
const departments = ["Network", "Fiber", "Support"];
const monitorTypes = ["Fiber", "ADSL", "Cable"];

const UserEditForm = ({ selectedUser, onClose }) => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        role: "",
        department: "",
        monitorType: "",
        status: "active",
    });

    useEffect(() => {
        if (selectedUser) {
            setForm({
                name: selectedUser.name || "",
                email: selectedUser.email || "",
                phone: selectedUser.phone || "",
                role: selectedUser.role || "",
                department: selectedUser.department || "",
                monitorType: selectedUser.monitorType || "",
                status: selectedUser.status || "active",
            });
        }
    }, [selectedUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));
    };


    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            await updateDoc(doc(db, "users", selectedUser.id), {
                ...form,
            });
            toast.success("User updated successfully");
            onClose();
        } catch (err) {
            console.error(err);
            toast.error("Failed to update user");
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg">
                <h2 className="text-lg font-semibold mb-4">Edit User</h2>
                <form onSubmit={handleUpdate} className="space-y-3">
                    <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Name"
                        className="w-full border p-2 rounded"
                    />
                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="Email"
                        className="w-full border p-2 rounded"
                    />
                    <input
                        type="text"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="Phone"
                        className="w-full border p-2 rounded"
                    />

                    <CustomSelect
                        name={'role'}
                        placeholder="Select Role"
                        options={roles}
                        value={form.role}
                        onChange={handleSelectChange}
                    />


                    <CustomSelect
                        name={"department"}
                        placeholder="Select Department"
                        options={departments}
                        value={form.department}
                        onChange={handleSelectChange}
                    // onChange={(value) => handleSelectChange('department', value)}
                    />

                    <CustomSelect
                        name={"monitorType"}
                        placeholder="Select Monitor Type"
                        options={monitorTypes}
                        value={form.monitorType}
                        onChange={handleSelectChange}
                    />

                    <CustomSelect
                        name={'status'}
                        placeholder="Select Monitor Type"
                        options={["Active", "Inactive"]}
                        value={form.status}
                        onChange={handleSelectChange}
                    />

                    <div className="flex justify-end gap-2 pt-3">
                        <button
                            type="button"
                            className="px-4 py-2 bg-gray-400 rounded text-white"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-600 rounded text-white hover:bg-blue-700"
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserEditForm;


// import React, { useState, useEffect } from "react";
// import { collection, onSnapshot, addDoc, updateDoc, deleteDoc, doc, Timestamp } from "firebase/firestore";
// import { db } from "../network/firebaseConfig";
// import toast from "react-hot-toast";

// const roles = ["helpdesk", "technician", "supervisor", "admin"];
// const departments = ["Network", "Fiber", "Support"];
// const monitorTypes = ["Fiber", "ADSL", "Cable"];

// const UserManagement = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [form, setForm] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         role: "",
//         department: "",
//         monitorType: "",
//         status: "active",
//     });
//     const [editId, setEditId] = useState(null);

//     // Real-time snapshot
//     useEffect(() => {
//         const unsubscribe = onSnapshot(collection(db, "users"), (snapshot) => {
//             const allUsers = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//             setUsers(allUsers);
//             setLoading(false);
//         });

//         return () => unsubscribe();
//     }, []);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (!form.name || !form.email || !form.role) {
//                 return toast.error("Name, Email, and Role are required");
//             }

//             if (editId) {
//                 // Update existing user
//                 await updateDoc(doc(db, "users", editId), {
//                     ...form,
//                 });
//                 toast.success("User updated successfully");
//                 setEditId(null);
//             } else {
//                 // Add new user
//                 await addDoc(collection(db, "users"), {
//                     ...form,
//                     createdAt: Timestamp.now(),
//                 });
//                 toast.success("User added successfully");
//             }

//             setForm({
//                 name: "",
//                 email: "",
//                 phone: "",
//                 role: "",
//                 department: "",
//                 monitorType: "",
//                 status: "active",
//             });
//         } catch (err) {
//             console.error(err);
//             toast.error("Failed to save user");
//         }
//     };

//     const handleEdit = (user) => {
//         setForm({
//             name: user.name || "",
//             email: user.email || "",
//             phone: user.phone || "",
//             role: user.role || "",
//             department: user.department || "",
//             monitorType: user.monitorType || "",
//             status: user.status || "active",
//         });
//         setEditId(user.id);
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm("Are you sure you want to delete this user?")) {
//             try {
//                 await deleteDoc(doc(db, "users", id));
//                 toast.success("User deleted successfully");
//             } catch (err) {
//                 console.error(err);
//                 toast.error("Failed to delete user");
//             }
//         }
//     };

//     if (loading) return <p>Loading users...</p>;

//     return (
//         <div className="max-w-5xl mx-auto p-6">
//             <h2 className="text-xl font-semibold mb-4">{editId ? "Edit User" : "Add New User"}</h2>

//             {/* User Form */}
//             <form onSubmit={handleSubmit} className="space-y-4 mb-6">
//                 <div>
//                     <label className="block font-medium">Name</label>
//                     <input
//                         type="text"
//                         name="name"
//                         value={form.name}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         required
//                     />
//                 </div>

//                 <div>
//                     <label className="block font-medium">Email</label>
//                     <input
//                         type="email"
//                         name="email"
//                         value={form.email}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         required
//                     />
//                 </div>

//                 <div>
//                     <label className="block font-medium">Phone</label>
//                     <input
//                         type="text"
//                         name="phone"
//                         value={form.phone}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                     />
//                 </div>

//                 <div>
//                     <label className="block font-medium">Role</label>
//                     <select
//                         name="role"
//                         value={form.role}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                         required
//                     >
//                         <option value="">Select Role</option>
//                         {roles.map((r) => (
//                             <option key={r} value={r}>{r}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div>
//                     <label className="block font-medium">Department</label>
//                     <select
//                         name="department"
//                         value={form.department}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                     >
//                         <option value="">Select Department</option>
//                         {departments.map((d) => (
//                             <option key={d} value={d}>{d}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div>
//                     <label className="block font-medium">Monitor Type</label>
//                     <select
//                         name="monitorType"
//                         value={form.monitorType}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                     >
//                         <option value="">Select Monitor Type</option>
//                         {monitorTypes.map((m) => (
//                             <option key={m} value={m}>{m}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div>
//                     <label className="block font-medium">Status</label>
//                     <select
//                         name="status"
//                         value={form.status}
//                         onChange={handleChange}
//                         className="w-full border p-2 rounded"
//                     >
//                         <option value="active">Active</option>
//                         <option value="inactive">Inactive</option>
//                     </select>
//                 </div>

//                 <button
//                     type="submit"
//                     className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
//                 >
//                     {editId ? "Update User" : "Add User"}
//                 </button>
//             </form>

//             {/* Users Table */}
//             <h2 className="text-xl font-semibold mb-2">All Users</h2>
//             <table className="w-full table-auto border-collapse border border-gray-300">
//                 <thead>
//                     <tr className="bg-gray-100">
//                         <th className="border p-2">Name</th>
//                         <th className="border p-2">Email</th>
//                         <th className="border p-2">Role</th>
//                         <th className="border p-2">Department</th>
//                         <th className="border p-2">Monitor Type</th>
//                         <th className="border p-2">Status</th>
//                         <th className="border p-2">Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {users.map((u) => (
//                         <tr key={u.id} className="hover:bg-gray-50">
//                             <td className="border p-2">{u.name}</td>
//                             <td className="border p-2">{u.email}</td>
//                             <td className="border p-2">{u.role}</td>
//                             <td className="border p-2">{u.department || "-"}</td>
//                             <td className="border p-2">{u.monitorType || "-"}</td>
//                             <td className="border p-2">{u.status}</td>
//                             <td className="border p-2 space-x-2">
//                                 <button
//                                     className="bg-yellow-400 text-white px-2 py-1 rounded"
//                                     onClick={() => handleEdit(u)}
//                                 >
//                                     Edit
//                                 </button>
//                                 <button
//                                     className="bg-red-600 text-white px-2 py-1 rounded"
//                                     onClick={() => handleDelete(u.id)}
//                                 >
//                                     Delete
//                                 </button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// export default UserManagement;
